import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../environments/environment";

@Component({
  selector: "twx-menu",
  templateUrl: "./app.menu.component.html",
  standalone: false,
})
export class AppMenuComponent implements OnInit {
  isMaintenanceExpanded = false;

  /** Hide in-development features from external client-preview viewers. */
  readonly previewMode = environment.previewMode;

  private readonly router = inject(Router);

  ngOnInit() {
    this.isMaintenanceExpanded = this.router.url.startsWith("/maintenance");
  }
}
